import { createSlice } from '@reduxjs/toolkit';

const emptyUserInfo = {
    name: '',
    idCode: '',
    birthDate: '',
    gender: '',
    address: '',
    status: '',
    mobile: '',
    accessToken: localStorage.getItem('accessToken'),
    loginInfo: true,
    loadingProfile: true,
};

const initialState = {
    userInfo: { ...emptyUserInfo },
    error: null,
    loginInfo: {
        loginApi: false
    },
    travelInfo: {
        travelId: ''
    },
};

const UserInformation = createSlice({
    name: 'userinformation',
    initialState,
    reducers: {
        setUserInformation: (state, action) => {
            // Most callers update only part of the user object.
            // Merging prevents accessToken/profile fields from being erased.
            state.userInfo = {
                ...state.userInfo,
                ...action.payload,
            };
            state.error = null;
        },
        clearUserInformation: (state) => {
            state.userInfo = {
                ...emptyUserInfo,
                accessToken: null,
                loadingProfile: false,
            };
            state.error = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const {
    setUserInformation: setUser,
    clearUserInformation: clearUser,
    setError: setHandleError
} = UserInformation.actions;

export default UserInformation.reducer;
